import React from "react";
import { useTranslation } from "react-i18next";
import { Eyebrow } from "../components/ui.jsx";
import { wireLinkStyles } from "./Privacy.jsx";

export default function TermsOfUse() {
  const { t } = useTranslation();
  const accessList = t("legal.terms.accessList", { returnObjects: true });
  const createList = t("legal.terms.createList", { returnObjects: true });
  const createSubList = t("legal.terms.createSubList", { returnObjects: true });
  const protectList = t("legal.terms.protectList", { returnObjects: true });
  const copyrightList = t("legal.terms.copyrightList", { returnObjects: true });
  const finalList = t("legal.terms.finalList", { returnObjects: true });
  const definitionsContentList = t("legal.terms.definitionsContentList", { returnObjects: true });

  return (
    <main>
      <section className="bg-wash">
        <div className="container" style={{ padding: "56px 24px 56px", maxWidth: 880 }}>
          <Eyebrow>{t("legal.eyebrow")}</Eyebrow>
          <h1 className="tt-h tt-h-xl" style={{ marginTop: 24 }}>{t("legal.terms.title")}</h1>
          <Html as="p" style={prose} html={t("legal.terms.intro")} />
        </div>
      </section>

      <section style={{ padding: "8px 0 120px" }}>
        <div className="container" style={{ maxWidth: 820 }}>

          <H2>{t("legal.terms.definitionsH")}</H2>
          <Html as="p" style={prose} html={t("legal.terms.definitionsP1")} />
          <Html as="p" style={prose} html={t("legal.terms.definitionsAccount")} />
          <Html as="p" style={prose} html={t("legal.terms.definitionsContent")} />
          <ul style={listStyle}>
            {definitionsContentList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ul>
          <Html as="p" style={prose} html={t("legal.terms.definitionsWebsite")} />
          <Html as="p" style={prose} html={t("legal.terms.definitionsUser")} />
          <Html as="p" style={prose} html={t("legal.terms.definitionsAbuse")} />

          <H2>{t("legal.terms.accessH")}</H2>
          <ol style={listStyle}>
            {accessList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ol>

          <H2>{t("legal.terms.createH")}</H2>
          <ol style={listStyle}>
            {createList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ol>
          <ul style={listStyle}>
            {createSubList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ul>
          <Html as="p" style={prose} html={t("legal.terms.createNote")} />

          <H2>{t("legal.terms.protectH")}</H2>
          <ol style={listStyle}>
            {protectList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ol>

          <H2>{t("legal.terms.copyrightH")}</H2>
          <ol style={listStyle}>
            {copyrightList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ol>

          <H2>{t("legal.terms.finalH")}</H2>
          <ol style={listStyle}>
            {finalList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ol>
        </div>
      </section>
    </main>
  );
}

function Html({ as: Tag = "p", html, style, className }) {
  return <Tag style={style} className={className} dangerouslySetInnerHTML={{ __html: wireLinkStyles(html) }} />;
}

const prose = {
  marginTop: 16,
  fontSize: 16,
  lineHeight: 1.7,
  color: "var(--ink-2)",
  maxWidth: 760
};

const listStyle = {
  marginTop: 12,
  paddingLeft: 22,
  fontSize: 16,
  lineHeight: 1.7,
  color: "var(--ink-2)",
  maxWidth: 760,
  display: "flex",
  flexDirection: "column",
  gap: 10
};

function H2({ children }) {
  return (
    <h2
      className="tt-h tt-h-md"
      style={{ marginTop: 56, scrollMarginTop: 96 }}
    >
      {children}
    </h2>
  );
}
